import React from 'react';
import SettlementsContent from '../../pages/Settlements.tsx';

const SettlementsTab: React.FC = () => {
  return <SettlementsContent />;
};

export default SettlementsTab;
